import { render, staticRenderFns } from "./OrderSetting.vue?vue&type=template&id=37b2d6d8"
import script from "./OrderSetting.vue?vue&type=script&lang=js"
export * from "./OrderSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports